import { useCallback, useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { playCoin } from "@/sound";

export default function CoinRain() {
  const [bursts, setBursts] = useState([]);
  const idRef = useRef(0);

  const spawn = useCallback((x, y) => {
    const id = ++idRef.current;
    const coins = Array.from({ length: 9 }, (_, i) => ({
      key: `${id}-${i}`,
      dx: (Math.random() - 0.5) * 280,
      up: -(Math.random() * 170 + 70),
      down: Math.random() * 220 + 200,
      size: Math.random() * 14 + 16,
      rot: (Math.random() - 0.5) * 720,
      delay: Math.random() * 0.06,
    }));
    setBursts((b) => [...b.slice(-4), { id, x, y, coins }]);
    setTimeout(() => setBursts((b) => b.filter((bb) => bb.id !== id)), 1600);
  }, []);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const handler = (e) => {
      if (e.button !== 0) return;
      spawn(e.clientX, e.clientY);
      playCoin();
    };
    window.addEventListener("pointerdown", handler);
    return () => window.removeEventListener("pointerdown", handler);
  }, [spawn]);

  return (
    <div className="pointer-events-none fixed inset-0 z-[90]" aria-hidden="true" data-testid="coin-rain-layer">
      {bursts.map((b) =>
        b.coins.map((c) => (
          <motion.span
            key={c.key}
            initial={{ x: 0, y: 0, scale: 0, rotate: 0, opacity: 1 }}
            animate={{
              x: c.dx,
              y: [0, c.up, c.up + c.down],
              scale: [0, 1, 1, 0.85],
              rotate: c.rot,
              opacity: [1, 1, 1, 0],
            }}
            transition={{
              duration: 1.4,
              delay: c.delay,
              times: [0, 0.32, 0.85, 1],
              ease: ["easeOut", "easeIn", "easeIn"],
            }}
            className="absolute flex items-center justify-center rounded-full border border-[#B8860B] font-display font-black text-[#07080A]"
            style={{
              left: b.x,
              top: b.y,
              width: c.size,
              height: c.size,
              fontSize: c.size * 0.5,
              background: "radial-gradient(circle at 35% 30%, #F6C85F, #B8860B)",
              boxShadow: "0 0 12px rgba(246,200,95,0.5)",
            }}
          >
            $
          </motion.span>
        ))
      )}
    </div>
  );
}
